import { Box, Stack } from '@mui/material';
import React from 'react';
import { useGetRecurringRevenue } from '../../../../../../../hooks/requests/use-get-recurring-revenue';
import { FinancialInsightsInvoices } from './financial-Insights-components/FinancialInsightsInvoices';
import { FinancialInsightsSection } from './financial-Insights-components/FinancialInsightsSection';

type FinancialInsightsProps = {
  customerId: string;
};

export const FinancialInsights: React.FC<FinancialInsightsProps> = ({ customerId }) => {
  const { data } = useGetRecurringRevenue(customerId);

  const financialData = {
    mrr: data?.monthlyRecurringRevenue,
    arr: data?.annualRecurringRevenue,
    transactions: 0,
    scheduledFees: 0,
    invoiceLineItemsScheduled: 0,
    revenueForecast: 0,
  };

  return (
    <Stack direction="column" sx={{
      gap: 2
    }}>
      <Box
        sx={{
          borderRadius: '8px',
          background: 'linear-gradient(79deg, #DEE8FF 0.79%, #D9F3EE 107.23%)',
          padding: '20px',
        }}
      >
        <FinancialInsightsSection mrr={financialData.mrr} arr={financialData.arr} customerId={customerId} />
      </Box>
      <FinancialInsightsInvoices />
    </Stack>
  );
};
